import { RespuestaArchivoEndosoDto } from "../models/respuestaArchivoEndoso"
import { Dialog, DialogContent, DialogTitle, Grid2 } from '@mui/material';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import { FileEndosoDto } from "../models/fileEndosoDto";
import { useColumnsArchivos } from "../utils/columnsArchivo";
import { useMemo, useState } from "react";
import Tabla from '../../../../components/ui/materialui/tabla';
import {FilterList} from "@mui/icons-material"
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';

interface IProps{
    files: RespuestaArchivoEndosoDto;
    show: boolean;
    onHide: () => void;
}

export const ModalResultadoArchivo = ({show, onHide, files} : IProps) => {

    const handleDownload = (file: FileEndosoDto) => {
        const link = document.createElement("a");
        link.href = `data:application/octet-stream;base64,${file.fileContent}`;
        link.download = file.fileName;
        link.click();
    };

    const allFiles = files.archivosEndosos.concat([{fileName: files.nombreArchivoZip, fileContent: files.contenidoArchivoZip}])

    const { COLUMNSARCHIVOS } = useColumnsArchivos({ handleDownload });
    const columns = useMemo(() => COLUMNSARCHIVOS, [handleDownload]);

    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    });

    const handleClose = (event: any, reason: any) => {
        if (reason === 'backdropClick') return;
        onHide();
    };

    const handleConfirm = () => {
        setModalConfirmacion({
            show: true,
            title: 'Confirmación',
            message: `¿Estás seguro de cerrar la descarga de archivos? Una vez cerrado, no puede volver a descargar los archivos`,
            metodo: () => {
                onHide()
            },
        });
    }

    return (
        <>
            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({ ...modalConfirmacion, show: false })
                }
                onConfirm={modalConfirmacion.metodo}
                show={modalConfirmacion.show}
                message={modalConfirmacion.message}
                title={modalConfirmacion.title}
            />
            <Dialog
                open={show}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    Archivos Generados
                </DialogTitle>
                <DialogContent>
                    <Grid2 container size={10} spacing={1} sx={{ textAlign: "left", justifyContent: 'center' }}>
                        <Tabla
                            data={allFiles}
                            columns={columns}
                        />
                    </Grid2>
                    <Grid2 size={4} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: "15px" }}>
                        <MButton variant="contained" color="primary" startIcon={<FilterList />} onClick={handleConfirm}>
                            Cerrar
                        </MButton>
                    </Grid2>
                </DialogContent>
            </Dialog>
        </>    
    )
}